import React    from 'react';

import Freetext              from './Freetext';
import Facts                 from './Facts';
import MissingMapPlaceholder from './MissingMapPlaceholder';
import OverviewActorMap      from './OverviewActorMap';

import Flux         from '../../../flux/Flux';
import Translations from '../../../utils/Translations';

const InfoOverview = ({actorData, routes}) => {

    const distance =  actorData.distance || null;
    const markers  = [
        {
            type:      'ImageMarker', 
            actorId:   actorData.id, 
            position:  actorData.geoLocation, 
            imagePath: actorData.previewPicture, 
            noPopup:   true, 
        },
        distance && {
            type:      'TextMarker',
            actorId:   actorData.id,
            position:  actorData.geoLocation,
            text:      `${Translations.get('actor_profile.about_me-facts-distance')} <span class=\"h-color-text-dark\">${Math.round(distance)}km</span>`,
        }
    ].filter(Boolean);

    return (
        <div className={"overview_info-container"}>
            <Freetext
                isCouple         = {actorData.isCouple}
                isOverview       = {true}
                freeText         = {actorData.freeText}
                freeTextHeadline = {actorData.freeTextHeadline}
                freeTextBody     = {actorData.freeTextBody}
                routeAboutMe     = {routes?.aboutMe?.path}
            />
             <Facts
                actorName    = {actorData.name}
                age          = {actorData.age}
                country      = {actorData.country}
                cupSizePlain = {actorData.cupSizePlain}
                distance     = {actorData.distance || null}
                gender       = {actorData.gender}
                isCouple     = {actorData.isCouple}
                isMale       = {actorData.isMale}
                isOverview   = {true}
                manPenisSize = {actorData.manPenisSize}
                sexuality    = {actorData.sexuality}
                size         = {actorData.size}
                weight       = {actorData.weight}
                zip          = {actorData.zip}
            />
            {actorData.isCouple 
                ? <Facts 
                    age              = {actorData.partner.age}
                    country          = {actorData.partner.country}
                    cupSizePlain     = {actorData.partner.cupSizePlain}
                    distance         = {actorData.distance || null}
                    gender           = {actorData.partner.isMale ? Flux.Constants.ActorGender.MALE : Flux.Constants.ActorGender.FEMALE}
                    isAboutMyPartner = {true}
                    isCouple         = {actorData.isCouple}
                    isMale           = {actorData.partner.isMale}
                    isOverview       = {true}
                    manPenisSize     = {actorData.partner.manPenisSize}
                    sexuality        = {actorData.partner.sexuality}
                    size             = {actorData.partner.size}
                    weight           = {actorData.partner.weight}
                    zip              = {actorData.partner.zip}
                /> 
                : (actorData.geoLocation.length > 0
                    ? <OverviewActorMap 
                        geoLocation = {actorData.geoLocation}
                        markers     = {markers}
                    />
                    : <MissingMapPlaceholder 
                        actorName = {actorData.name} 
                        actorId   = {actorData.id}
                    />
                )
            }
        </div>
    );
}

export default InfoOverview;
